import { Grid, Theme, styled, Paper } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

export const BlocksWrapper = styled('div')<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const StyledWrapper = styled('div')<Theme>(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

export const WorkSheetWrapper = styled('div')<Theme>(({ theme }) => ({
  paddingTop: theme.spacing(2),
}));

export const StyledLabel = styled('span')<Theme>(({ theme }) => ({
  color: theme.palette.grey['700'],
  fontStyle: 'italic',
}));

export const TotalExercisesByLevel = styled('div')<Theme>(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const StyledGrid = styled(Grid)<Theme>(({ theme }) => ({
  margin: theme.spacing(1, -1),
}));

export const LoadingMessage = styled('div')<Theme>(({ theme }) => ({
  padding: theme.spacing(1.5, 0, 0, 0),
}));

export const PageAggregatedBlocks = styled('div')<Theme, { isCluster: boolean }>(({ isCluster }) =>
  isCluster
    ? {}
    : {
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '2rem',
        border: '1px solid rgb(234, 230, 220)',
        marginBottom: '2rem',
      }
);

export const ClusterWrapper = styled(Paper)<Theme>(({ theme }) => ({
  borderRadius: theme.config.borderRadiusCluster,
  // padding: 'clamp(2rem, 4vw, 3rem)',
  // padding: '1rem',
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.config.appbarColors.borderColor}`,
  '@media print': {
    boxShadow: 'none',
  },
  zIndex: 4,
  marginBottom: '2rem',
}));

export const PageWrapper = styled(Paper)<Theme>(({ theme }) => ({
  borderRadius: theme.config.borderRadiusCluster,
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.config.appbarColors.borderColor}`,
  '@media print': {
    boxShadow: 'none',
  },
  zIndex: 4,
}));

export const BlockDropArea = styled(Skeleton)<Theme>(({ theme }) => ({
  backgroundColor: theme.palette.ternary.main,
  margin: '20px 0px',
  borderRadius: 5,
}));

export const Wrapper = styled('div')<Theme>(({ theme }) => ({
  position: 'relative',
}));

export const ExerciseListBlockWrapper = styled('div')<Theme>(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

export const StyledBlockWrapper = styled('div')<Theme, { condition: 'true' | 'false' }>(
  ({ theme, condition }) =>
    condition === 'true'
      ? {
          position: 'relative',
          margin: theme.spacing(0, 0, 4, 0),
          background: theme.palette.common.white,
          borderRadius: 15,
        }
      : {
          position: 'relative',
          margin: theme.spacing(0, 0, 4, 0),
        }
);

export const HoverScrollTarget = styled('div')({
  position: 'absolute',
  top: '-10rem',
  left: 0,
});
